// extracted by mini-css-extract-plugin
export default {"wrapper":"xz-z","viewport":"yz-z","container":"zz-z","slide":"Az-z"};